import {IFreePlayVouchersProvider} from "../free-play-vouchers.provider.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {CGPEventSubscription} from "../../../sdk/cgp-sdk.interface";
import {observable, runInAction} from "mobx";
import {
    IFreePlayVoucherData,
    IFreePlayVoucherDelta
} from "../../../../../common/interfaces/free-play/free-play-voucher-data.interface";
import {IFreePlayVoucherModel} from "../../vouchers/free-play-voucher.model.interface";
import {VouchersProviderBase} from "../vouchers-provider-base";

export class Tripe8FreePlayVouchersProvider extends VouchersProviderBase implements IFreePlayVouchersProvider {
    constructor(services: IServiceFactoryExtended) {
        super(services)
        this._cgpEventsSubscriptions.push(this.services.sdk.events.onFreePlayBatchAdded(this._onFreePlayBatchAddedHandler));
        this._cgpEventsSubscriptions.push(this.services.sdk.events.onFreePlayBatchUpdated(this._onFreePlayBatchUpdatedHandler));
        this._cgpEventsSubscriptions.push(this.services.sdk.events.onFreePlayBatchRemoved(this._onFreePlayBatchRemovedHandler));
    }


    private _cgpEventsSubscriptions: CGPEventSubscription[] = [];

    dispose() {
        this._cgpEventsSubscriptions.forEach(s => s.off());
        this._cgpEventsSubscriptions = [];

        this.vouchers.forEach(voucher => voucher.dispose());
        this.vouchers = [];
    }

    @observable
    vouchers: IFreePlayVoucherModel[] = [];

    private _findVoucher(voucherId: string): IFreePlayVoucherModel | null {
        return this.vouchers.find(v => v.id === voucherId.toString()) || null;
    }

    private _onFreePlayBatchAddedHandler = (vouchers: IFreePlayVoucherData[]) => {
        runInAction(() => {
            vouchers.forEach(voucherData => {
                const existingVoucher = this._findVoucher(voucherData.ID);
                if(existingVoucher) {
                    existingVoucher.updateVoucherData(voucherData);
                } else {
                    const voucherModel = this._createVoucherModel(voucherData);
                    if(voucherModel) {
                        this.vouchers.push(voucherModel);
                    }
                }
            });
        });
    }

    private _onFreePlayBatchUpdatedHandler = (vouchers: IFreePlayVoucherDelta[]) => {
        runInAction(() => {
            vouchers.forEach(voucherData => {
                const existingVoucher = this._findVoucher(voucherData.ID);
                if(existingVoucher) {
                    existingVoucher.updateVoucherData(voucherData);
                } else {
                    this.services.logger.warning(`Received voucher update event for a voucher that is not in the list! voucher ID = ${voucherData.ID}`);
                }
            });
        });
    }

    private _onFreePlayBatchRemovedHandler = (voucherIds: string[]) => {
        runInAction(() => {
            voucherIds.forEach(id => {
                const index = this.vouchers.findIndex(v => v.id === id);
                if(index >= 0) {
                    this.vouchers[index].dispose();
                    this.vouchers.splice(index, 1);
                }
            });
        });
    }

    async refreshVouchers(): Promise<void> {
        //No need to refresh vouchers for 888. They are coming through firebase
    }
}